import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ep-one-one',
  templateUrl: './ep-one-one.component.html',
  styleUrls: ['./ep-one-one.component.scss']
})
export class EpOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
